/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { memo } from 'react';
import Styles from '../css/CreateAccountPage.module.css';
import SWLogo from '../assets/SWLogoWhBg.png';
import CreateAccountForm from '../components/forms/CreateAccountForm';
import { CreateAccountProvider } from '../contexts/CreateAccountContext';

const CreateAccountPage = () => {
  return (
    <CreateAccountProvider>
      <section className={Styles.page}>
        <img className={Styles.swLogo} src={SWLogo} alt='Sun West Mortgage Company Inc.' />
        <section className={Styles.wrapperSection}>
          <CreateAccountForm />
        </section>
      </section>
    </CreateAccountProvider>
  );
};

export default memo(CreateAccountPage);
